import axios from "axios";

const API_URL = 'https://aspom-server.onrender.com/api-v1/'
// const API_URL = 'https://backend.aspomportal.com/api-v1/'
// const API_URL = 'http://localhost:5000/api-v1/'


export const api = axios.create({
    baseURL: API_URL,
    responseType: 'json'
})

export const apiRequest = async ({url, token, data, method, header})=>{
    try {
        const request = await api(url,{
            method: method || 'GET',
            data: data || {},
            headers: {
                "Content-Type": header ? header : "application/json",
                Authorization: token ? `Bearer ${token}` : '' 
            }
        })

        return request.data
    } catch (error) {
        console.log(error)
        const err = error.response?.data
        if(err.message === 'Authorization failed' || err.message === 'Authorization failed!'){
            // window.alert('Session timeout')
            localStorage.removeItem('Aspom_travels_agency')
            window.location.replace('/auth')
        }
        return {success: err.success, message: err.message, userId: err.userId}
    }
}


export const ipAccess = async ()=>{
    try {
        const response = await apiRequest({
            url: 'https://aspom-server.onrender.com',
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const userClockIn = async (token)=>{
    try {
        const response = await apiRequest({
            url: '/attendance/clock-in',
            method: 'POST',
            token
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const userClockOut = async (token)=>{
    try {
        const response = await apiRequest({
            url: '/attendance/clock-out',
            method: 'POST',
            token
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const userAttendance = async (token)=>{
    try {
        const response = await apiRequest({
            url: '/attendance',
            token
        })

        return response
    } catch (error) {
        console.log(error)
    }
}



export const getUserInfo = async (token, id)=>{
    try {
        const response = await apiRequest({
            url: id ? `/auth/account/${id}` : `/auth/account`,
            token: token,
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const getAllAcounts = async (token)=>{
    try {
        const response = await apiRequest({
            url: '/auth/accounts',
            token: token,
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const getAllUsers = async (token)=>{
    try {
        const response = await apiRequest({
            url: '/auth/users',
            token: token,
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const addEmployee = async (token, data)=>{
    try{
        const response = await apiRequest({
            url: '/auth/add-employee',
            method: 'POST',
            data: data,
            token
        })

        return response
    }catch(error){
        console.log(error)
    }
}

export const addAdmin = async (token, data)=>{
    try{
        const response = await apiRequest({
            url: '/auth/admin',
            method: 'POST',
            data: data,
            token
        })

        return response
    }catch(error){
        console.log(error)
    }
}

export const getAdmin = async (token)=>{
    try{
        const response = await apiRequest({
            url: '/auth/admin',
            token
        })

        return response
    }catch(error){
        console.log(error)
    }
}


export const addLists = async (token, data)=>{
    try {
        const response = await apiRequest({
            url: 'task/add-list',
            method: 'POST',
            data: data,
            token: token,
        })

        return response
    } catch (error) {
        console.log(error)
    }
}


export const getLists = async (token)=>{
    try {
        const response = await apiRequest({
            url: 'task/get-lists',
            token: token,
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const getAllReports = async (token)=>{
    try {
        const response = await apiRequest({
            url: 'task/get-reports',
            token: token,
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const updateProfile = async (token, data, id) => {
    try {
        const response = await apiRequest({
            url: `auth/update/${id}`,
            data: data,
            method: 'PUT',
            header: 'multipart/form-data',
            token: token
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const getNotifications = async (token) => {
    try {
        const response = await apiRequest({
            url: 'task/notifications',
            token: token
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const deleteNotifications = async (token, id) => {
    try {
        const response = await apiRequest({
            url: `task/delete-notifications/${id}`,
            method: 'DELETE',
            token: token
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const fetchMail = async (token, accessToken)=>{
    try {
        const response = await apiRequest({
            url: `auth/mail/${accessToken}`,
            method: 'GET',
            token: token
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const sendForgotPass = async (data) =>{
    try {
        const response = await apiRequest({
            url: '/auth/forgot-password',
            method: 'POST',
            data: data
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const sendResetPass = async (data, id) =>{
    try {
        const response = await apiRequest({
            url: `/auth/reset-password/${id}`,
            method: 'POST',
            data: data
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const getResetLink = async (id, token) =>{
    try {
        const response = await apiRequest({
            url: `/auth/password-link/${id}/${token}`,
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const verificationCode = async (id, code) =>{
    try {
        const response = await apiRequest({
            url: `/auth/verification/${id}/${code}`,
            method: 'POST',
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const changePassword = async (token, data) => {
    try {
        const response = await apiRequest({
            url: '/auth/change-password',
            method: 'PUT',
            data,
            token
        })

        return response
    } catch (error) {
        console.log(error)
    }
}